<div [id]="documentMapId + 'input'" style="margin-bottom: 30px">
  <pr-input-abstract
    [isDefault]="isDefault"
    [control]="fullAddress"
    [label]="label"
    [derrors]="derrors"
    [highlightOnValue]="highlightOnValue"
    [highlightOnFocus]="highlightOnFocus"
    [hidden]="!isGMaps"
    [required]="true"
  >
    <input
      #mapsInput
      matInput
      type="text"
      [formControl]="fullAddress"
      placeholder="Saisissez un lieu"
      style="width: 100%"
      class="pr-map-input"
      name="place"
    />
    <ng-content></ng-content>
  </pr-input-abstract>
  @if (control) {
    <div [formGroup]="control">
      <div [hidden]="isGMaps" class="pr-map-inputs-container">
        <pr-input
          label="Adresse"
          [derrors]="derrors"
          [highlightOnValue]="highlightOnValue"
          [highlightOnFocus]="highlightOnFocus"
          ><input formControlName="street" type="text" [readOnly]="disabled" />
        </pr-input>
        <pr-input
          label="Code postal"
          [derrors]="derrors"
          [highlightOnValue]="highlightOnValue"
          [highlightOnFocus]="highlightOnFocus"
          ><input
            formControlName="zipCode"
            type="text"
            [readOnly]="disabled"
            mask="99999"
        /></pr-input>
        <pr-input
          label="Ville"
          [derrors]="derrors"
          [highlightOnValue]="highlightOnValue"
          [highlightOnFocus]="highlightOnFocus"
          ><input formControlName="city" type="text" [readOnly]="disabled" />
        </pr-input>
        <pr-input-country
          [formGroup]="control"
          [derrors]="derrors"
          [highlightOnValue]="highlightOnValue"
        ></pr-input-country>
      </div>
      <div>
        @if (hasCedex) {
          <pr-input
            [label]="'Cedex'"
            [derrors]="derrors"
            [highlightOnValue]="highlightOnValue"
            [highlightOnFocus]="highlightOnFocus"
            ><input formControlName="cedex" type="text" [readOnly]="disabled"
          /></pr-input>
        }
      </div>
    </div>
  }

  @if (mapOptions != null) {
    <div>
      <google-map
        [options]="mapOptions"
        height="181px"
        [id]="documentMapId"
        [hidden]="!isGMaps"
      >
        <map-marker [position]="marker.position"></map-marker>
      </google-map>
    </div>
  }

  <span class="gmap-toggle form-align-end" (click)="isGMaps = !isGMaps">{{
    isGMaps ? "Je ne trouve pas l'adresse" : 'Utiliser la recherche à nouveau.'
  }}</span>
</div>
